import React, {PropsWithChildren} from 'react';
import clsx from 'clsx';

type ComputedBoxProps = PropsWithChildren & {
  expanded: boolean;
  className?: string;
  durationMs?: number;
};
function ComputedBox({
  expanded,
  durationMs = 300,
  className,
  children,
}: ComputedBoxProps) {
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout>>();
  const [isMounted, setIsMounted] = React.useState(false);
  const [isTransitionFinished, setIsTransitionFinished] = React.useState(false);

  React.useEffect(() => {
    if (expanded) {
      setIsMounted(true);
      timeoutRef.current = setTimeout(() => {
        setIsTransitionFinished(true);
      }, durationMs);
    } else {
      setIsTransitionFinished(false);
      timeoutRef.current = setTimeout(() => {
        setIsMounted(false);
      }, durationMs);
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [expanded, durationMs]);

  if (!expanded && !isMounted) return null;
  return (
    <div
      className={clsx(
        className,
        'computed-box grid opacity-0 [grid-template-rows:0fr] [will-change:grid-template-rows,margin-top,padding-top] [&>div]:min-h-0',
        expanded && isMounted && 'opacity-100 [grid-template-rows:1fr]',
        isTransitionFinished ? 'overflow-visible' : 'overflow-hidden',
        !expanded && '!mt-0 !pt-0',
      )}
      style={{
        transition: `grid-template-rows ${durationMs}ms, opacity ${
          durationMs + 150
        }ms, margin-top ${durationMs + 100}ms, padding-top ${durationMs + 100}ms`,
      }}
    >
      <div>{children}</div>
    </div>
  );
}

export {ComputedBox};
